// extracted by mini-css-extract-plugin
export var bodySections = "_dc-8";
export var gray = "_dc-7";
export var green = "_dc-4";
export var iconContainer = "_dc-9";
export var iconWidgetContainer = "_dc-1";
export var phoneIcon = "_dc-2";
export var red = "_dc-5";
export var statusDot = "_dc-3";
export var widgetContainer = "_dc-0";
export var yellow = "_dc-6";